import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';
import { Button } from '../ui/button';
import { Card } from '../ui/card';
import { Input } from '../ui/input';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_easers-pro/artifacts/j38s08lp_LOGOSITE.png';

export function AdminLogin({ adminKey, onChange, onSubmit }) {
  return (
    <div className="min-h-dvh bg-background flex flex-col" data-testid="admin-login-page">
      <div className="px-4 sm:px-6 py-4">
        <Button asChild variant="ghost" size="sm" data-testid="admin-login-back-link">
          <Link to="/"><ArrowLeft className="h-4 w-4 mr-1" /> Retour au site</Link>
        </Button>
      </div>
      <div className="flex-1 flex items-center justify-center px-4 pb-16">
        <Card className="p-8 max-w-md w-full shadow-sm">
          <div className="flex items-center gap-3 mb-6">
            <img src={LOGO_URL} alt="Ptitservices.com" className="h-10 w-auto rounded-lg" />
            <div className="h-8 w-px bg-border" />
            <div className="w-10 h-10 rounded-xl bg-[hsl(var(--brand-mint))] flex items-center justify-center">
              <Shield className="h-5 w-5 text-[hsl(var(--primary))]" />
            </div>
          </div>
          <h1 className="font-['Space_Grotesk'] font-semibold text-xl">Back-office</h1>
          <p className="text-sm text-muted-foreground mt-1 mb-6">Leads, Easers, clients, contenus et réglages de l'agence.</p>
          <form className="space-y-4" onSubmit={(e) => { e.preventDefault(); onSubmit(); }}>
            <div>
              <label className="text-sm font-medium block mb-1" htmlFor="admin-key">Clé d'administration</label>
              <Input
                id="admin-key"
                type="password"
                autoComplete="current-password"
                value={adminKey}
                onChange={(e) => onChange(e.target.value)}
                placeholder="Entrez votre clé admin"
                data-testid="admin-key-input"
              />
            </div>
            <Button type="submit" className="w-full" data-testid="admin-login-button">
              Accéder au tableau de bord
            </Button>
          </form>
        </Card>
      </div>
    </div>
  );
}
